import firebase from '@/firebase';

import { SET_PROFILE, LOGOUT } from './mutations';


const state = {
  profile: {},
  loggedIn: false
};

const getters = {
  profile: ({profile}) => profile,
  loggedIn: ({loggedIn}) => loggedIn,
  isAuthorized: ({profile}) => (profile.email != "" && ["jice.lavocat@gmail.com", "jc.lavocat@okedito.com", "paul.perdrieu@okedito.com", "veronique.perdrieu@okedito.com", "nellie.jeannin@okedito.com", "pm.pacaud@okedito.com", "pmpacaud@gmail.com"].indexOf(profile.email) > -1)
};

const mutations = {
  [SET_PROFILE](state, profile) {
    state.loggedIn = true;
    state.profile = {
      name: profile.displayName,
      email: profile.email,
      picture: profile.photoURL
    };
  },
  [LOGOUT](state) {
    state.loggedIn = false;
    state.profile = {};
  }
};

const actions = {
  async login(store) {

    // if user is already logged in return
    if (store.state.loggedIn)
      return;

    const provider = new firebase.auth.GoogleAuthProvider();
    try {
      await firebase.auth().signInWithPopup(provider);
    } catch(error) {
      console.log(error);
    }
  },

  async logout() {
    try {
      await firebase.auth().signOut();
    } catch(error) {
      console.log(error);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/user/index.js